export default function RefreshButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="hover:opacity-80 transition-opacity"
      aria-label="Refresh"
      title="Refresh"
    >
      <svg
        width="25"
        height="25"
        className="md:w-[32px] md:h-[32px]"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="0.5" width="20" height="20" rx="4" fill="#E7E7E9" />
        <path
          d="M5.50024 10.5C5.50024 11.39 5.76416 12.26 6.25863 13.0001C6.7531 13.7401 7.4559 14.3169 8.27817 14.6575C9.10044 14.9981 10.0052 15.0872 10.8782 14.9135C11.7511 14.7399 12.5529 14.3113 13.1822 13.682C13.8116 13.0526 14.2401 12.2508 14.4138 11.3779C14.5874 10.505 14.4983 9.60019 14.1577 8.77792C13.8171 7.95566 13.2403 7.25285 12.5003 6.75839C11.7603 6.26392 10.8903 6 10.0002 6C8.74222 6.00473 7.53473 6.49561 6.63024 7.37L5.50024 8.5"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.50024 6V8.5H8.00024"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
